import config from "./config";
var axios = config();

export default {
  getContentForStudent(asurite, type, category) {
    return axios.get(
      "/api/Content/GetContentForStudent?asurite=" +
        asurite +
        "&type=" +
        type +
        "&category=" +
        category
    );
  },
  // get
  getContent() {
    return axios.get("/api/Content/GetContent");
  },

  getContentById(id) {
    return axios.get("/api/Content/GetContentById/" + id);
  },

  getAcademicPlans() {
    return axios.get("/api/Content/GetAcademicPlans");
  },

  getTags() {
    return axios.get("/api/Content/GetTags");
  },

  // post
  createContentView(contentId) {
    return axios.post("/api/Content/CreateContentView/" + contentId);
  },

  createContent(content) {
    return axios.post("/api/Content/CreateContent", content);
  },

  // put
  editContent(content) {
    return axios.put("/api/Content/EditContent", content);
  }
};
